'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const OptionContext = /*#__PURE__*/React.createContext({
  option: {
    value: '',
    ariaLabel: ''
  },
  isSelected: false,
  isFocused: false,
  isDisabled: false,
  isHovered: false
});
const useOption = () => React.useContext(OptionContext);
function OptionProvider(_ref) {
  let {
    children,
    state
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement(OptionContext.Provider, {
    value: state
  }, children);
}

exports.OptionProvider = OptionProvider;
exports.useOption = useOption;
